// Puerto verbatim de packages/hce/src/hce/tramoB.ts.
export interface EntradaTramoB {
  readonly codigo: string;
  readonly grupo: string;
}

export const TRAMO_B: EntradaTramoB[] = [
  { codigo: '010A', grupo: 'diagnostico' },
  { codigo: '010B', grupo: 'diagnostico' },
  { codigo: '012A', grupo: 'diagnostico' },
  { codigo: '012B', grupo: 'diagnostico' },
  { codigo: '013A', grupo: 'diagnostico' },
  { codigo: '013B', grupo: 'diagnostico' },
  { codigo: '118', grupo: 'diagnostico' },
  { codigo: '122', grupo: 'diagnostico' },
  { codigo: '117', grupo: 'documentos' },
  { codigo: '116-cert', grupo: 'documentos' },
  { codigo: '053', grupo: 'referencias' },
  { codigo: '038', grupo: 'referencias' },
  { codigo: '119', grupo: 'referencias' },
  { codigo: '120', grupo: 'referencias' },
  { codigo: 'Anexo1', grupo: 'referencias' },
  { codigo: 'Anexo2', grupo: 'referencias' },
  { codigo: '028A-1', grupo: 'mediciones' },
  { codigo: '028B-1', grupo: 'mediciones' },
  { codigo: '028B-2', grupo: 'mediciones' },
  { codigo: '028C-1', grupo: 'mediciones' },
  { codigo: '028C-2', grupo: 'mediciones' },
  { codigo: '034', grupo: 'mediciones' },
  { codigo: '018A', grupo: 'mediciones' },
  { codigo: '019', grupo: 'mediciones' },
  { codigo: '017', grupo: 'quirurgico' },
  { codigo: '018', grupo: 'quirurgico' },
  { codigo: '016', grupo: 'quirurgico' },
  { codigo: '016A', grupo: 'quirurgico' },
  { codigo: '016B', grupo: 'mediciones' },
  { codigo: '016C', grupo: 'mediciones' },
  { codigo: '060', grupo: 'quirurgico' },
  { codigo: '028A', grupo: 'pediatria' },
  { codigo: '028B', grupo: 'pediatria' },
  { codigo: '028C', grupo: 'pediatria' },
  { codigo: '028', grupo: 'pediatria' },
  { codigo: '051', grupo: 'gineco-obstetricia' },
  { codigo: '052', grupo: 'gineco-obstetricia' },
  { codigo: '056', grupo: 'adolescentes' },
  { codigo: '056A', grupo: 'adolescentes' },
  { codigo: '056B', grupo: 'adolescentes' },
  { codigo: '057', grupo: 'adulto-mayor' },
  { codigo: '057A', grupo: 'adulto-mayor' },
  { codigo: '058', grupo: 'adulto-mayor' },
  { codigo: '058A', grupo: 'adulto-mayor' },
  { codigo: '033', grupo: 'odontologia' },
  { codigo: '121', grupo: 'psicologia' },
  { codigo: '114', grupo: 'uci' },
  { codigo: '115', grupo: 'uci' },
  { codigo: '113', grupo: 'uci' },
  { codigo: '059', grupo: 'seguridad-paciente' },
  // 054/055 son discretos del Grupo 4 (Anexo 1 MSP, resumen interno de
  // laboratorio sin recurso FHIR propio — ver discretos/formularioResumenMsp.tsx),
  // no Questionnaire — quedan en 'diagnostico' junto al resto de la familia
  // de laboratorio (010A/010B). Grupo 5 (Módulo H) real: FEMO/escalas
  // clínicas, sí Questionnaire nuevos (namespace propio para las escalas,
  // ver catalogoEspecialidades.ts).
  { codigo: '054', grupo: 'diagnostico' },
  { codigo: '055', grupo: 'diagnostico' },
  { codigo: 'FEMO', grupo: 'documentos' },
  { codigo: 'esc-phq9', grupo: 'psicologia' },
  { codigo: 'esc-nyha', grupo: 'escalas-clinicas' },
  { codigo: 'esc-glasgow', grupo: 'escalas-clinicas' },
];
